"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Directive, ElementRef, Input, Optional, Renderer2, SkipSelf, } from '@angular/core';
import { FlexDirective as FlexLayoutFlexDirective, LayoutDirective as FlexLayoutLayoutDirective, LayoutWrapDirective as FlexLayoutLayoutWrapDirective, MediaMonitor, } from '@angular/flex-layout';
var FlexDirective = (function (_super) {
    __extends(FlexDirective, _super);
    function FlexDirective(monitor, elRef, renderer, _container, _wrap) {
        var _this = _super.call(this, monitor, elRef, renderer, _container, _wrap) || this;
        _this._container = _container;
        _this._wrap = _wrap;
        return _this;
    }
    Object.defineProperty(FlexDirective.prototype, "flex", {
        set: function (val) {
            this._cacheInput('flex', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexDirective.prototype, "flexMobile", {
        set: function (val) {
            this._cacheInput('flexMobile', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexDirective.prototype, "flexTablet", {
        set: function (val) {
            this._cacheInput('flexTablet', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexDirective.prototype, "flexDesktopSmall", {
        set: function (val) {
            this._cacheInput('flexDesktopSmall', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexDirective.prototype, "flexDesktopLarge", {
        set: function (val) {
            this._cacheInput('flexDesktopLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexDirective.prototype, "flexDesktopXLarge", {
        set: function (val) {
            this._cacheInput('flexDesktopXLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexDirective.prototype, "flexDesktopXXLarge", {
        set: function (val) {
            this._cacheInput('flexDesktopXXLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input('flLayoutFlex'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexDirective.prototype, "flex", null);
    __decorate([
        Input('flLayoutFlex.mobile'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexDirective.prototype, "flexMobile", null);
    __decorate([
        Input('flLayoutFlex.tablet'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexDirective.prototype, "flexTablet", null);
    __decorate([
        Input('flLayoutFlex.desktop-small'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexDirective.prototype, "flexDesktopSmall", null);
    __decorate([
        Input('flLayoutFlex.desktop-large'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexDirective.prototype, "flexDesktopLarge", null);
    __decorate([
        Input('flLayoutFlex.desktop-xlarge'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexDirective.prototype, "flexDesktopXLarge", null);
    __decorate([
        Input('flLayoutFlex.desktop-xxlarge'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexDirective.prototype, "flexDesktopXXLarge", null);
    FlexDirective = __decorate([
        Directive({
            selector: "\n    [flLayoutFlex],\n    [flLayoutFlex.mobile],\n    [flLayoutFlex.tablet],\n    [flLayoutFlex.desktop-small],\n    [flLayoutFlex.desktop-large],\n    [flLayoutFlex.desktop-xlarge],\n    [flLayoutFlex.desktop-xxlarge],\n  ",
        }),
        __param(3, Optional()),
        __param(3, SkipSelf()),
        __param(4, Optional()),
        __param(4, SkipSelf()),
        __metadata("design:paramtypes", [MediaMonitor,
            ElementRef,
            Renderer2,
            FlexLayoutLayoutDirective,
            FlexLayoutLayoutWrapDirective])
    ], FlexDirective);
    return FlexDirective;
}(FlexLayoutFlexDirective));
export { FlexDirective };



// WEBPACK FOOTER //
// flex.directive.js